/**
 * Set the laoding indicator
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_LOADING = state => {
    state.loading = true
}

/**
 * Set the laoding indicator
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_LOADING = state => {
    state.loading = false
}

/**
 * Set the data payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SET_DATA = (state, payload) => {
    state.data = payload
}

/**
 * Set the errors
 *
 * @param  {Object} state
 * @param  {Object} errors
 * @return {Void}
 */
const SET_ERRORS = (state, errors) => {
    state.errors = errors
}

export default {
    SET_DATA,
    SET_ERRORS,
    SET_LOADING,
    RESET_LOADING
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/sensitivity-analysis/mutations.js